import { createContext, Dispatch, SetStateAction } from 'react';
import {
  CreateDataRoomTermsAndConditionsPayload,
  DataRoomTermsAndConditions,
  UpdateDataRoomTermsAndConditionsPayload,
} from '../../models/DataRoomTermsAndConditions';
import utils from 'utils';

type TermsAndConditionsContextProps = {
  isLoading: boolean;
  isShowingDeleted: boolean;
  activeItems: DataRoomTermsAndConditions[];
  deletedItems: DataRoomTermsAndConditions[];
  setIsShowingDeleted: Dispatch<SetStateAction<boolean>>;
  onDelete: (_id: string) => void;
  onRestore: (_id: string) => void;
  addNewTermsAndConditions: (
    values: CreateDataRoomTermsAndConditionsPayload,
  ) => Promise<DataRoomTermsAndConditions | null>;
  updateExistingTermsAndConditions: (
    _id: string,
    values: UpdateDataRoomTermsAndConditionsPayload,
  ) => Promise<DataRoomTermsAndConditions | null>;
};

export default createContext<Partial<TermsAndConditionsContextProps>>({
  isLoading: false,
  isShowingDeleted: false,
  activeItems: [],
  deletedItems: [],
  setIsShowingDeleted: utils.noop,
  onDelete: utils.noop,
  onRestore: utils.noop,
  addNewTermsAndConditions: utils.noop,
  updateExistingTermsAndConditions: utils.noop,
});
